import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import StickyMobileCTA from './components/StickyMobileCTA';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';

const Offerings = lazy(() => import('./pages/Offerings'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Contact = lazy(() => import('./pages/Contact'));
const GetInTouch = lazy(() => import('./pages/GetInTouch'));
const About = lazy(() => import('./pages/About'));
const Packages = lazy(() => import('./pages/Packages'));
const FAQsPage = lazy(() => import('./pages/FAQs'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const AdminLogin = lazy(() => import('./pages/admin/Login'));
const AdminDashboard = lazy(() => import('./pages/admin/Dashboard'));
const NotFound = lazy(() => import('./pages/NotFound'));
const AgShows = lazy(() => import('./pages/verticals/AgShows'));
const Festivals = lazy(() => import('./pages/verticals/Festivals'));
const Schools = lazy(() => import('./pages/verticals/Schools'));
const ScienceWeek = lazy(() => import('./pages/verticals/ScienceWeek'));
const Charity = lazy(() => import('./pages/verticals/Charity'));

function PageLoader() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-amber/30 border-t-amber rounded-full animate-spin" />
        <p className="text-sm text-charcoal/40 font-mono uppercase tracking-wider">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-cream">
      <Helmet
        titleTemplate="%s | Jurassic Jack"
        defaultTitle="Jurassic Jack | Roarsome Adventure Entertainment"
      />
      <ScrollToTop />
      <Header />
      <main>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/offerings" element={<Offerings />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-in-touch" element={<GetInTouch />} />
            <Route path="/about" element={<About />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            {/* Vertical pages — new SEO-friendly routes */}
            <Route path="/agricultural-shows" element={<AgShows />} />
            <Route path="/festivals-and-community-events" element={<Festivals />} />
            <Route path="/schools-and-kinders" element={<Schools />} />
            <Route path="/national-science-week" element={<ScienceWeek />} />
            <Route path="/charity-and-community" element={<Charity />} />
            {/* Legacy redirects — keep old routes working */}
            <Route path="/ag-shows" element={<AgShows />} />
            <Route path="/festivals" element={<Festivals />} />
            <Route path="/schools" element={<Schools />} />
            <Route path="/science-week" element={<ScienceWeek />} />
            <Route path="/charity" element={<Charity />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <StickyCTA />
      <StickyMobileCTA />
    </div>
  );
}

export default App;
